/**
 * AISettingsPage
 * --------------
 *
 * September 2026
 *
 * One place to pick the AI provider/model the app uses (AIProviderPanel).
 * Pages that use the AI (e.g. the DOE Analyzer) only read the connection
 * status and link back here.
 */
import * as React from "react";

import AIProviderPanel from "./AIProviderPanel.js";
import "./AISettings.css";

function AISettingsPage() {
  return (
    <div className="settings-page">
      <div className="settings-header">
        <div>
          <h1>AI Settings</h1>
          <p>Connect an AI provider for AI-generated analysis. Everything else in the app works without one.</p>
        </div>
      </div>

      <AIProviderPanel />
    </div>
  );
}

export default AISettingsPage;
